import React from 'react';
import type { AnswerShapeId } from '../../brand';

/**
 * Siluetas de las cuatro opciones.
 *
 * Rellenas, no de contorno: a diez metros de un proyector una silueta maciza se
 * distingue y un trazo fino no. Las cuatro tienen perímetros claramente
 * distintos entre sí, de modo que la opción se reconoce sin depender del color
 * —lo que importa tanto para quien no distingue tonos como para quien mira la
 * pantalla de reojo desde el fondo del aula.
 */

const PATHS: Record<AnswerShapeId, string> = {
  // Hexágono regular, vértice arriba.
  hex: 'M12 2 L21 7 L21 17 L12 22 L3 17 L3 7 Z',
  // Estrella de cinco puntas.
  star: 'M12 2 L14.9 8.6 L22 9.4 L16.7 14.2 L18.2 21.2 L12 17.6 L5.8 21.2 L7.3 14.2 L2 9.4 L9.1 8.6 Z',
  // Gota: punta arriba, vientre redondo abajo.
  drop: 'M12 2 C12 2 4.5 10.2 4.5 15 A7.5 7.5 0 0 0 19.5 15 C19.5 10.2 12 2 12 2 Z',
  // Luna creciente.
  moon: 'M20.5 15.2 A9 9 0 1 1 10.3 3.2 A7.2 7.2 0 0 0 20.5 15.2 Z',
};

export const AnswerShapeIcon: React.FC<{
  shape: AnswerShapeId;
  className?: string;
}> = ({ shape, className = 'w-7 h-7' }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d={PATHS[shape]} />
  </svg>
);
